import { getMangoCallsAsync } from 'services/mangoCallService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { GetMangoCallsRequest } from 'services/dtoModels/mangoCall/getMangoCallsRequest';
import type { SWRResponse } from 'swr';

export const SWR_MANGO_CALLS_ENDPOINT = 'mango-office/calls';

type SWRMangoCallsData = Awaited<ReturnType<typeof getMangoCallsAsync>>;

const useMangoCalls = (
  request: GetMangoCallsRequest,
  shouldFetch = true
): SWRResponse<SWRMangoCallsData, AxiosError> =>
  useSWR(
    shouldFetch ? [SWR_MANGO_CALLS_ENDPOINT, request] : null,
    async ([_, params]) => await getMangoCallsAsync(params)
  );

export default useMangoCalls;
